import React from 'react'
import CustomButton from '../shared/customButton/CustomButton';
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions';
import { useHistory } from 'react-router';
import { useAppDispatch } from '../redux/hooks';
import heroImage from './../assets/images/heroImage3.webp';
import {Helmet} from "react-helmet-async";

const questions = [
  {
    question: 'How will my tickets be delivered?',
    answer: <p>All tickets at Rail Online are eTickets. You'll receive your eTicket via email after confirmation.</p>
  },
  {
    question: `Why can't I book a sleeper cabin?`,
    answer: <p> Rail Online will be offering a full range of sleeper options from 2023. Stay tuned!</p>
  },
  {
    question: 'Does my ticket include a seat reservation?',
    answer: <p>Seat reservations are included on Acela services and in Business Class on the Northeast Regional, Palmetto, Carolinian and Vermonter trains.</p>
  },
  {
    question: 'Is my e-ticket my actual  ticket?',
    answer: <p>Yes, simply show your eticket barcode on your mobile device along with your ID to the conductor. Or print out a copy of your eticket before boarding. </p>
  },
  {
    question: 'How far in advance can I book an Amtrak service?',
    answer: <p>Amtrak tickets are bookable up to 11 months in advance.</p>
  },
  {
    question: 'How much luggage can I take onboard with me?',
    answer: <p>Each passenger may bring two personal items (12kg, 14 x 11 x 17 inches each) and two carry-on items (23kg, 28 x 22 x 14 inches) onboard. All luggage must be tagged with your name and address.</p>
   
  },
  {
    question: 'Can I take my bicycle?',
    answer: <p><a href="https://www.amtrak.com/onboard/bring-your-bicycle-onboard.html" target="_blank" rel="noreferrer"> Amtrak Bike FAQs</a></p>
  }, 
  {
    question: 'Does my ticket entitle me to lounge access?',
    answer: <p>Private lounge access is available at select stations for Acela First Class passengers and sleeping car passengers. </p>
  },
  {
    question: 'How far in advance should I arrive at the train station?',
    answer: <p>We recommend arriving at the train station at least 30 minutes prior to your scheduled train departure. If you require assistance with luggage or other services we suggest arriving even earlier.</p>
  },
  {
    question: 'What is the difference between the Acela and the North East Regional?',
    answer: <p>Acela offers fast service between Boston - New York - Washington DC and other intermediate cities. You will enjoy a fast trip with fewer stops, free wifi and spacious seating. The Northeast Regional offers an affordable and comfortable way to travel between Boston - Washington DC </p>
  }, 
  {
    question: 'Where does Amtrak go?',
    answer: <p><a href="https://www.amtrak.com/routes.html" target="_blank" rel="noreferrer"> Amtrak Routes & Stations</a></p>
  },
  {
    question: 'Does Amtrak offer baggage assistance and how do I book it?',
    answer: <p>Amtrak offers free assistance with luggage at many major train trains. Just look out for the uniformed Red Caps for assistance. </p>
  },
  {
    question: `Are there any prohibited items that I can't take on Amtrak trains?`,
    answer: <p><a href="https://www.amtrak.com/onboard/baggage-policy/baggage-prohibited-items.html" target="_blank" rel="noreferrer"> Items Prohibited on Amtrak</a></p>
  },
  {
    question: `Will my ticket say which platform the train departs from?`,
    answer: <p>Boarding gates are usually annouched 15 minutes prior to the train's departure. Many stations have monitors and signs that displays the boarding gate locations for each train. </p>
  },
  {
    question: `Will I need to show any ID on the train?`,
    answer: <p>Travellers aged 18+ on Amtrak trains will be required to produce valid photo identification if asked.</p>
  },
]
const onboardFaq = [
{
  question: `Can I purchase food onboard the train?`,
  answer: <p>Food and drinks are available to purchase in Dining and Cafe cars onboard, however food purchased can only be consumed in those cars. </p>
},
{
  question: `Can I take food onboard the train?`,
  answer: <p>You may take your own food and beverages onboard for consumption at your seat or private sleeping car accomodation.  </p>
},
{
  question: `What is the difference between First, Business and Coach class?`,
  answer: <p>First Class is exclusive to Acela services. First Class passengers can enjoy priority boarding, premium amenities, complimentary onboard food & drink and access to lounges in select stations.  Relax in spacious seating and enjoy the complimentary WiFi. Business Class offers wide, comfortable seating with extra legroom, with non-alcoholic complimentary drinks to enjoy (not offered with Acela Business Class). Seat reservations are provided on many routes. Coach Class is offered on all Amtrak services and provides wide, reclinging seats with ample legroom, at-seat trays, a reading light and electric outlets.   </p>
},
{
  question: `Do Amtrak trains have wifi?`,
  answer: <p>Amtrak trains offer free basic WiFi services on select train and stations.</p>
},
{
  question: `Are meals included with my ticket?`,
  answer: <p>When travelling in a Private Sleeping Car, meals are complimentary. </p>
},
{
  question: `How many passengers can fit in the sleeping cars?`,
  answer: <p>With the exception of Family Bedrooms and Bedroom Suites, all Sleeping Car rooms accommodate one or two travelers per room. </p>
},
{
  question: `What's the difference between a Viewliner and a Superliner Roomette? `,
  answer: <p>A Superliner features two levels of private accommodations per car and a Viewliner features a single level. The type of car will depend on your route.  </p>
},
{
  question: `Do all Private Rooms have a restroom and shower?   `,
  answer: <p>Roomettes and Family Bedrooms have access to close-by restroom and showers in the Sleeping Car. Bedrooms and Bedrooms Suites have In-Room restroom and showers.   </p>
},
{
  question: `How many children can be accommodated in the Family Bedroom?`,
  answer: <p>Family Bedrooms are the perfect size for two adults and two children (aged 2 - 12).  </p>
},
]

function AmtrakFaq() {
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
      <Helmet>
        <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
        <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
        <link rel="canonical" href="https://www.rail.online/amtrak"/>
      </Helmet>
      <div className="hero-image-container">
        <div className="background-shade d-none d-md-flex opacity-change"></div>
        <img className="img-fluid hero-image d-none d-md-flex" src={heroImage} alt="heroImage" loading='lazy' />
        <div className="about-us-page--title">
          <h1>Amtrak FAQ's</h1>
          {/* <h2>Save on your UK train tickets by booking in advance.</h2> */}
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            

            <h3 className="mt-5 mb-3 text-left">Frequently Asked Questions</h3>
            <h3 className="mt-5 mb-3 text-left">Before departure</h3>

            {
              questions.map(({ question, answer }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3">{answer}</div>
                </div>
              ))
            }
             <h3 className="mt-5 mb-3 text-left">Onboard Experience</h3>

             {
              onboardFaq.map(({ question, answer }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3">{answer}</div>
                </div>
              ))
            }
            <h3 className="mt-5 mb-4">Ready to save on Amtrak train tickets?</h3>
            <div className="d-flex w-100 justify-content-center">
              <CustomButton
                text="BOOK A TRIP"
                className="go-btn"
                onClick={() => {
                  dispatch(setSelectedSearchBoxTab('Train Tickets'));
                  history.push('/')
                }} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AmtrakFaq
